import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';

const Poi = () => {
    const {
        Address,
        PhoneList,
        WebUrl,
        Longtitude,
        Latitude,
        Grade,
        CheckIn,
        CheckOut,
    } = useSelector((state: RootState) => state.itinerariesReducer);

    return (
        <div className={styles.poiInfoWrapper}>
            {Address && (
                <div>
                    <h4>地址</h4>
                    <div>
                        {Address}
                        <a
                            href={`http://maps.google.com/maps?q=${Latitude},${Longtitude}`}
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            看地圖
                        </a>
                    </div>
                </div>
            )}
            {PhoneList.length > 0 && (
                <div>
                    <h4>電話</h4>
                    <div>
                        {PhoneList.map((item: string) => (
                            <div key={item}>{item}</div>
                        ))}
                    </div>
                </div>
            )}
            {WebUrl && (
                <div>
                    <h4>網址</h4>
                    <div>{WebUrl}</div>
                </div>
            )}
            {Grade.length > 0 && (
                <div>
                    <h4>參考等級</h4>
                    <div>
                        {Grade}
                        {Grade.map((item: string) => (
                            <span key={item}>{item}</span>
                        ))}
                    </div>
                </div>
            )}
            {CheckIn && (
                <div>
                    <h4>CHECK IN</h4>
                    <div>{CheckIn}</div>
                </div>
            )}
            {CheckOut && (
                <div>
                    <h4>CHECK OUT</h4>
                    <div>{CheckOut}</div>
                </div>
            )}
        </div>
    );
};

export default Poi;
